module.exports = "/assets/data/a0ce7044b971b2e6f6bb639ff0027c97-MK45.data.json";